/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('swiper', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "auto": "",
      "loop": "",
      "dots-position": "center",
      "dots-class": "dots-class",
      "aspect-ratio": 0.4,
      "interval": 5000
    }
  }, _vm._l(_vm.bannerList, function (item, index) {
    return _c('swiper-item', {
      key: index,
      staticClass: "banner-list"
    }, [_c('img', {
      attrs: {
        "src": item.img_url,
        "width": "100%",
        "height": "100%"
      }
    })]);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };